<template minapp="mpx" xlang="wxml">
  <Drawer
    wx:if="{{!repeat}}"
    externStyle="{{customStyle}}"
    headerStyle="{{headerStyle}}"
    show="{{show}}"
    showMask
    showCloseBtn="{{false}}"
    bind:close="closeDrawer"
  >
    <view class="container">
      <hlText
        class="hl-text"
        text="{{hightlightText}}"
        color="#666"
        hlColor="#FF6400"
        hlStyle="{{hlStyle}}"
      />
      <view class="price-difference"
        >是否再次提升抢票速度至{{ recommendAccPackageName }}抢票，+{{ priceDifference }}元/单</view
      >
      <view class="diff-status-card">
        <view class="cur-pack">
          <view class="title">{{ curAccProgressName }}</view>
          <view class="sub-title">领先{{ curAccProgressPercent }}%的用户</view>
        </view>
        <view class="recommend-pack">
          <view class="title">{{ recommendAccPackageName }}</view>
          <view class="sub-title"
            >领先 <view class="number">{{ recommendAccPackagePercent }}</view
            ><view class="unit">%</view>的用户</view
          >

          <image
            class="up-icon"
            src="https://ut-static.udache.com/webx/sfc/bDw1P-JhbkeGwgWVcIE7r.png"
          />
        </view>
      </view>
      <view class="tip-container">
        <view class="tips">
          <view class="tip" wx:for="{{popRightsTips}}" wx:key="index">
            <image class="icon" wx:if="{{item.icon}}" src="{{item.icon}}" />
            <view class="text" wx:if="{{item.title}}">{{ item.title }}</view>
          </view>
        </view>
      </view>
      <view class="btn-area">
        <Button externClass="btn disagree" bindclick="closeDrawerAndSubmit">否</Button>
        <Button externClass="btn agree" bindclick="confirm">是</Button>
      </view>
    </view>
  </Drawer>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import store from '@/store'
  import { getFinalPrice } from '@/utils/money'
  import { trackEvent } from '@/common/track'
  import { getStorage, setStorage } from '@/utils/storage'
  import { TICKET_RETENTION_POPUP_TIMES } from '@/utils/train-storage'
  import dayjs from 'dayjs'

  createComponent({
    props: {
      show: {
        type: Boolean,
        value: false
      }
    },
    data() {
      return {
        headerStyle: {
          paddingTop: 0
        },
        customStyle: {
          borderRadius: '20px 20px 0 0',
          overflow: 'hidden'
        },
        hlStyle: {
          fontFamily: 'PingFangSC-Medium',
          fontWeight: '500'
        },
        popupId: 10000,
        uniqueId: 'scramble-retention-drawer'
      }
    },
    created() {
      if (__mpx_mode__ == 'web') {
        const curPopupNum = this.uniquePopupMap?.[this.uniqueId] || 0
        this.updateUniquePopupMap({
          [this.uniqueId]: curPopupNum + 1
        })
        this.popupId = curPopupNum + 1
      }
    },
    watch: {
      show: {
        handler(val) {
          if (val && !this.repeat) {
            const preTimesObj = getStorage(TICKET_RETENTION_POPUP_TIMES)
            const preTicketTimesObj = preTimesObj.scramble || {}
            const timestamp = preTicketTimesObj.timestamp || 0
            const curTimestamp = dayjs().unix()
            const times = preTicketTimesObj.times || 0
            const isSameDay = dayjs.unix(timestamp).isSame(dayjs.unix(curTimestamp), 'day')
            const updatedGrabTimes = {
              times,
              timestamp
            }
            if (isSameDay) {
              updatedGrabTimes.times = times + 1
            } else {
              updatedGrabTimes.times = 1
            }
            updatedGrabTimes.timestamp = curTimestamp
            setStorage({
              key: TICKET_RETENTION_POPUP_TIMES,
              data: {
                ...preTimesObj,
                scramble: updatedGrabTimes
              }
            })
            trackEvent(
              'yks_train_conorder_speedupfloat_sw',
              '迎客松-火车票-确认订单页-加速包浮层-曝光',
              {
                now: this.curAccProgressName,
                suggest: this.recommendAccPackageName,
                number: updatedGrabTimes.times,
                module: this.scrambleBtnTrackType
              }
            )
          }
        },
        immediate: true
      }
    },
    detached() {},
    computed: {
      ...store.mapState({
        selectSeatInfo: 'train.selectSeatInfo',
        packageInfo: 'train.packageInfo', //返回的加速包模块信息
        selectPackage: 'train.selectPackage', //最终选中的加速包信息
        trainInfo: 'train.trainInfo',
        scrambleBtnTrackType: 'makeOrder.scrambleBtnTrackType',
        uniquePopupMap: 'common.uniquePopupMap'
      }),
      hightlightText() {
        return this.packagePopupInfo?.pop_title || ''
      },
      repeat() {
        return this.popupId < (this.uniquePopupMap?.[this.uniqueId] || 0)
      },
      curAccProgressName() {
        return this.selectPackage?.status_name === '不加速'
          ? '低速'
          : this.selectPackage?.status_name || ''
      },
      curAccProgressStatus() {
        return this.selectPackage?.status || 0
      },
      curAccProgressPercent() {
        return this.selectPackage?.percent || 0
      },
      packagePopupInfo() {
        return this.packageInfo?.pop_info || {}
      },
      popRightsTips() {
        return this.packagePopupInfo?.pop_rights_tips || []
      },
      recommendAccPackageInfo() {
        let recommentStatus = this.packagePopupInfo?.pop_level || 0
        // 无需处理上限情况 弹窗开启时候已校验
        if (this.curAccProgressStatus >= recommentStatus) {
          recommentStatus = this.curAccProgressStatus + 10
        }
        const _recommendAccPackageInfo =
          this.packageInfo?.packages?.find((item) => item?.status === recommentStatus) || {}
        return _recommendAccPackageInfo
      },
      recommendAccPackageName() {
        return this.recommendAccPackageInfo?.status_name || ''
      },
      recommendAccPackagePercent() {
        return this.recommendAccPackageInfo?.percent || 0
      },
      recommendAccPackageIndex() {
        return (
          this.packageInfo?.packages?.findIndex(
            (item) => item?.status === this.recommendAccPackageInfo?.status
          ) || 0
        )
      },
      priceDifference() {
        return getFinalPrice(
          (this.recommendAccPackageInfo?.real_price || 0) - (this.selectPackage?.real_price || 0)
        )
      }
    },
    methods: {
      ...store.mapMutations({
        closeScrambleRetentionDrawer: 'makeOrder.closeScrambleRetentionDrawer',
        setAddedServiceSource: 'makeOrder.setAddedServiceSource',
        setSelectPackageItem: 'train.setSelectPackageItem',
        setSelectPackageIndex: 'train.setSelectPackageIndex',
        setSelectPackage: 'train.setSelectPackage',
        updateUniquePopupMap: 'common.updateUniquePopupMap'
      }),
      closeDrawer(e) {
        const type = e?.detail.type
        if (type === 'mask') {
          this.ckTrackEvent(2)
        }
        this.closeScrambleRetentionDrawer()
      },
      closeDrawerAndSubmit() {
        this.ckTrackEvent(0)
        this.closeScrambleRetentionDrawer()
        this.triggerEvent('submit')
      },
      confirm() {
        this.setAddedServiceSource(['make_order_confirm_btn_float__accelerate']) // 埋点数据-记录选择加速包位置
        this.setSelectPackageIndex(this.recommendAccPackageIndex)
        this.setSelectPackageItem(this.recommendAccPackageInfo)
        this.setSelectPackage(this.recommendAccPackageInfo)
        this.ckTrackEvent(1)
        this.closeScrambleRetentionDrawer()
        this.triggerEvent('submit')
      },
      ckTrackEvent(button) {
        const preTimesObj = getStorage(TICKET_RETENTION_POPUP_TIMES)
        const preTicketTimesObj = preTimesObj.scramble || {}
        const times = preTicketTimesObj.times
        trackEvent('yks_train_conorder_speedupfloat_ck', '迎客松-火车票-确认订单页-加速包浮层-点击', {
          now: this.curAccProgressName,
          button: button === 0 ? '否' : button === 1 ? '是' : '关闭',
          suggest: this.recommendAccPackageName,
          number: times,
          module: this.scrambleBtnTrackType
        })
      }
    },
    detached() {
      if (__mpx_mode__ == 'web') {
        this.updateUniquePopupMap({
          [this.uniqueId]: this.popupId - 1
        })
      }
    }
  })
</script>

<style scoped lang="stylus">
  @font-face
    font-family Bebas Neue
    src url('https://ut-static.udache.com/webx/sfc/6TZbL8WaY5143mEBV1QO__BebasNeue-1-Medium.otf')
  .container
    position relative
    box-sizing border-box
    padding 32px 20px 34px 20px
    display flex
    flex-direction column
    align-items center
    background linear-gradient(106deg, #FFF5EE 2%, #E5F9F6 85%)
    .hl-text
      font-size 14px
      line-height 20px
      margin-bottom 1.5px
    .price-difference
      font-size 14px
      line-height 20px
      color #666
      font-family PingFangSC-Regular
      font-weight 400
      margin-bottom 28px
    .diff-status-card
      height 125px
      width 275px
      display flex
      align-items flex-end
      margin-bottom 15px
      .cur-pack
        flex-shrink 0
        width 125px
        height 108px
        display flex
        flex-direction column
        justify-content center
        align-items center
        background #C2EEE5
        box-sizing border-box
        border 1px solid #b8e1d0
        color #3BB6A2
        border-radius 11.57px
        .title
          font-size 20px
          line-height 1
          font-family PingFangSC-Semibold
          font-weight 600
          margin-bottom 15px
        .sub-title
          font-size 12.5px
          line-height 1
          font-family PingFangSC-Medium
          font-weight 500
      .recommend-pack
        flex-shrink 0
        position relative
        width 160px
        height 100%
        display flex
        flex-direction column
        justify-content center
        align-items center
        background linear-gradient(330deg, #FF5900 5%, #FF8C00 85%)
        border 0.5px solid #FFED4C
        z-index 1
        transform translateX(-10px)
        color #fff
        border-radius 11.57px
        .title
          font-size 25px
          line-height 28px
          font-family PingFangSC-Semibold
          font-weight 600
          margin-bottom 15px
        .sub-title
          font-size 14px
          font-family PingFangSC-Medium
          font-weight 500
          display flex
          align-items baseline
          .number
            font-family Barlow Semi Condensed
            font-size 25px
            line-height 1
            font-weight 400
            color #FFED4C
          .unit
            font-family Bebas Neue
            font-size 25px
            line-height 1
            font-weight 400
            color #FFED4C
        .up-icon
          z-index 1
          position absolute
          width 50px
          height 33px
          left -25.5px
          bottom -4px
    .tip-container
      width 275px
      display flex
      justify-content center
      align-items center
      border-radius 8px
      background rgba(255, 255, 255, 0.7)
      padding 12px 33px
      box-sizing border-box
      margin-bottom 28px
      .tips
        width 100%
        display flex
        justify-content space-between
        align-items center
        flex-wrap wrap
        .tip
          font-size 13px
          line-height 20px
          color #333
          display flex
          align-items center
          .icon
            height 16px
            width 16px
            margin-right 4px
          .text
            font-size 13px
            line-height 20px
            font-family PingFangSC-Medium
            font-weight 500
    .btn-area
      width 100%
      display flex
      justify-content space-between
      .btn
        border-radius 8px
        box-sizing border-box
        display flex
        justify-content center
        align-items center
        font-size 16px
        padding 14px 0
      .disagree
        color #999
        font-family PingFangSC-Medium
        font-weight 500
        width 109px
        margin-right 8px
        border 1px solid #ccc
      .agree
        font-family PingFangSC-Semibold
        font-weight 600
        background #FF6400
        color #fff
        flex 1
</style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      Drawer: '@didi/spring-ui/ts-drawer',
      Button: '@didi/spring-ui/ts-button',
      'spring-icon': '@didi/spring-icon',
      hlText: '@didi/spring-ui/hl-text'
    }
  }
</script>